import { Text } from '@luminovo/design-system';

export function FormulaText(props: React.PropsWithChildren<{}>): JSX.Element {
    return <Text style={{ lineHeight: 2 }} {...props} />;
}
